import config from './config/system.main.config'

export default {

  CONFIG: config,

  auth(module, version, inteface) {
    return this.common(config.PREFIX.AUTH, module, version, inteface)
  },
  sys(module, version, inteface) {
    return this.common(config.PREFIX.SYS, module, version, inteface)
  },
  business(module, version, inteface) {
    return this.common(config.PREFIX.BUSINESS, module, version, inteface)
  },
  common(prefix, module, version, inteface = '') {
    return makeUrl(config.API, prefix, module, version, inteface)
  },
}

let makeUrl = function (api, prefix, module, version, inteface = '') {
  let url = api + '/'
  if (prefix) url += prefix + '/'
  if (module) url += module + '/'
  if (version) url += version + '/'
  if (inteface) url += inteface
  return url
}



